import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const NorfolkTidesLink = () => (
  <Link
    href={"https://am.ticketmaster.com/tides/"}
    target={"_blank"}
    sx={{
      color: "primary.main",
      textDecoration: "none",
      fontWeight: 500,
    }}
  >
    Account Manager
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Norfolk Tides account using our secure Ticketmaster login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your Tides <NorfolkTidesLink /> within 24
        hours of purchase. Reach out to Live Fan Support for any questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Norfolk Tides Flex Plan work?",
    description:
      "The Norfolk Tides Flex Plan allows fans to select any seat to games hosted by the Norfolk Tides. Simply log into your Tides Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description: "Yes, you must select all games at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all currently available inventory.",
  },
  {
    title: "Where are my tickets delivered?",
    description: (
      <>
        Tickets are delivered directly within your Tides <NorfolkTidesLink />.
      </>
    ),
  },
];
